export enum PipeResults {
  Axial = "Axial",
  Bending = "Bending",
  Collapse = "Collapse",
  Torsion = "Torsion",
}
